import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
    GetQuery,
    langCheck,
    cardIntervalFormat,
    getWindow,
    setThemeAndIframe,
    getWorkbenchData,
    setBodyClass,
    getRatio,
    isShowResolutionprompt,
    setIframeZoom,
    setNccFontSize,
    setNccFormStyle,
    setInsideTab,
    isInsideTab,
    setNccTableStyle,
    isValidString,
    isNestedWorkbench
} from "Pub/js/utils";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import { setStore, getStore } from "Pub/js/storageUtils";
import { ControlTip } from "Components/ControlTip";
import { withRouter } from "react-router-dom";
import {
    changeDrawer,
    changeBgState,
    setAccountInfo,
    setAvatar,
    setMessageData,
    setNewMsg,
    setKnowledge,
    setKnowledgeRule,
    setKnowledgeRuleOnce,
    setDisturbMode,
    setBreadCrumbClick,
    setThemeColor,
    setNccFont,
    setWorkbenchData,
    setWatermarkInfo,
} from "Store/appStore/action";
import { setGridMargin } from "Store/GridLayout/action";
import { updateAllowPaint } from "Store/ifr/action";
import NavBar from "./NavBar";
import SideDrawer from "./SideDrawer";
import APPDataStoreInit from "./APPDataStore/APPDataStoreInit";
import APPDataController from "./APPDataStore/APPDataController";
import PEDataController from "./APPDataStore/PEDataController";
import BusinessInfoController from "./APPDataStore/BusinessInfoController";
import ResolutionPrompt from './ResolutionPrompt';
// import ResolutionPromptUser from './ResolutionPrompt/ResolutionPromptUser'
// 友互通 注册组件
import AccountActivationEntry from "./AccountActivationEntry";
// 友互通实名认证弹框 
import RealNameAuthentication from '/Components/RealNameAuthentication';
// 工作桌面单页通用布局
import TabsLink from "./headerComponents/TabsLink"; // 这个不能删，桌面配置的按钮是由之前的分组改的，有依赖于样式文件，之后可做优化
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import "./index.less";
import Knowledge from "./Knowledge";
import { pageToWithMsgType } from "./pageToAction";
import moment from "moment";
import platform from "Pub/js/platform";
import BrowserTab from "./browserTabs";
const { ConnectSocket, DongbaToLocalTime, getLangCode, PubSub, toast, clearUrlParams } = platform;
import Watermark from "../pages/Customize/Watermark";
import { getWaterMarkObject, getBackgroundObject } from "../pages/CompanyStyleSetting/common";
import { NoNeedWatermarkRoutes } from "../routes";
import WidgetJSLoader from "../pages/NewHome/CreaterForWidget/WidgetJSLoader";

const dateFormat = "YYYY-MM-DD HH:mm:ss";

/**
 * 工作桌面整体布局组件
 */
class Layout extends Component {
    constructor(props) {
        super(props);
        this.canLoadMsgCount = true;
        this.state = {
            showAllApp: false,
            navAppInfo: null,
            nodeName: langCheck("0000PUB-000105"), /* 国际化处理： 首页*/
            navShow: true,
            hideNav: false,
            showResolutionprompt: false,
            showResolutionPromptUser: false,
            resolutionPromptUserType: 1,
            // lastZoom: '' || getStore('zoom'),
            // zoom: '' || getStore('zoom')
            logo: null,
            systemNotifiC: null,
            tabActived: null, // 内部页签模式下当前激活的页签
            microTempData: null,
        };
        //本文件sonar扫描箭头函数不能解析，为了让sonar扫描通过，只能先这么写
        this.handleUpdateTitleName = this.handleUpdateTitleName.bind(this);
        this.updateTitle = this.updateTitle.bind(this);
        this.handleSprClick = this.handleSprClick.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.closeCallback = this.closeCallback.bind(this);
        this.showNotification = this.showNotification.bind(this);
        this.receiveMessage = this.receiveMessage.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.setTimeoutGetMessageCount = this.setTimeoutGetMessageCount.bind(this);
        this.getMessageCount = this.getMessageCount.bind(this);
        this.setMessageCount = this.setMessageCount.bind(this);
        this.getKnowledge = this.getKnowledge.bind(this);
        this.didMountGetMessage = this.didMountGetMessage.bind(this);
        this.clearIntervalGetMessage = this.clearIntervalGetMessage.bind(this);
        this.clearTimeOutGetMessage = this.clearTimeOutGetMessage.bind(this);
        this.clearIntervaldisturbTimer = this.clearIntervaldisturbTimer.bind(this);
        this.appClose = this.appClose.bind(this);
        this.alertmsg = this.alertmsg.bind(this);
        this.accountDataController = this.accountDataController.bind(this);
        this.appDataUpdate = this.appDataUpdate.bind(this);
        this.setDefault = this.setDefault.bind(this);
        this.getDefaultColor = this.getDefaultColor.bind(this);
        this.getDistubInfo = this.getDistubInfo.bind(this);
        this.onUserSelectModule = this.onUserSelectModule.bind(this);
        this.reSetIntervalDisturb = this.reSetIntervalDisturb.bind(this);
        this.setIntervalDisturb = this.setIntervalDisturb.bind(this);
        this.closeDisturbMode = this.closeDisturbMode.bind(this);
        this.getKnowledgeRuleOnce = this.getKnowledgeRuleOnce.bind(this);
        this.layoutRefresh = this.layoutRefresh.bind(this);
        this.handleHotKey = this.handleHotKey.bind(this);
        this.changeAllApp = this.changeAllApp.bind(this);
        this.onBreadCrumbClick = this.onBreadCrumbClick.bind(this);
        this.closeNotLoginModal = this.closeNotLoginModal.bind(this);
        this.handleNavVisible = this.handleNavVisible.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.introJs = null;
    }
    componentWillMount() {
        let sprType = localStorage.getItem("spr");
        if (sprType && !JSON.parse(sprType)) {
            // 开启渲染时间和渲染次数记录
            //window.sys_monitor.startMonitor();
            sessionStorage.setItem('sys_flag_bmonitor', true);
        }
        let infoData = getStore("STOREFORINFODATA", true);
        if (this.props.location.pathname === "/" || !infoData) {
            this.initAppData(true);
            this.getKnowledgeRuleOnce();
        } else {
            this.initAppData();
        }
        // 设置缩放
        setIframeZoom();
    }

    initAppData = (reload = false, businessCallback) => {
        if (reload) {
            APPDataStoreInit(() => {
                this.appDataUpdate(businessCallback);
            });
        } else {
            this.appDataUpdate(businessCallback);
        }
    }

    componentDidMount() {
        this.setCacheTheme();
        // 获取工作台数据
        const urlObj = GetQuery(this.props.location.search);
        const params = {};
        if (urlObj.workbenchid) {
            params.workbenchid = urlObj.workbenchid;
        } else {
            // 加载系统通知组件（工作台设计和预览不需要）
            WidgetJSLoader('/nccloud/resources/uap/common/components/SystemNotifi/index.js', key => {
                this.setState({
                    systemNotifiC: window[key].default
                })
            });
        }
        getWorkbenchData(params).then(data => {
            this.props.setWorkbenchData(data);
            PubSub.publish("workbenchDataReady");
        });
        //监听缩放
        // window.addEventListener("resize", this.handleScreenRationChange)
        // console.log(getStore("STOREFORINFODATA", true))
        this.didMountGetMessage();
        this.addMessageListener();
        // 获取勿扰模式信息
        this.getDistubInfo();
        // 获取存储的主题颜色
        this.getDefaultColor(() => {
            this.handleUpdateTitleName();
            window.addEventListener("hashchange", this.handleHashChange);
        });
        this.handleKnowledge();
        // this.setIntervalHeartbeat(); //2020.12版本去掉心跳请求
        this.alertmsg();
        // IM消息互斥
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
        window.addEventListener("beforeunload", this.appClose);
        document.addEventListener("keydown", this.handleHotKey);
        // this.publishMsg();
        window.onbeforeunload = this.layoutRefresh;
        this.handleNavVisible(); //控制导航栏显隐
        window.top.addEventListener('message', this.handleMessage);
        // 监听是否打开新手引导
        this.introJs = PubSub.subscribe("introJs", (action, data) => {
            this.setState({ navDisable: data });
        });
        console.log(getRatio());
        // 分辨率提示
        this.setResolutionprompt();
        // this.resolutionprompt = setTimeout(() => {
        //     this.setResolutionprompt();
        // }, 1000);
        // this.resolutionPromptUser = PubSub.subscribe('resolutionPromptUser', (action, type) => {
        //     this.setState({
        //         resolutionPromptUserType: type,
        //         showResolutionPromptUser: true
        //     })
        // })
        window.updateMicroOnMain = this.handleUpdateMicroOnMain;
        window.controlAppScreen = this.handleControlAppScreen;
        this.reloadAppDataPubSub = PubSub.subscribe("reloadAppData", (action, callback) => {
            this.initAppData(true, callback);
        });
    }
    componentWillUnmount() {
        window.removeEventListener("hashchange", this.handleHashChange);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        // window.removeEventListener("resize", this.handleScreenRationChange)
        window.removeEventListener("beforeunload", this.appClose);
        this.clearIntervalGetMessage();
        document.removeEventListener("keydown", this.handleHotKey);
        this.removeMessageListener();
        window.top.removeEventListener("message", this.handleMessage);
        this.introJs && PubSub.unsubscribe(this.introJs); //移除订阅
        // PubSub.unsubscribe(this.resolutionPromptUser);
        window.updateMicroOnMain = null;
        PubSub.unsubscribe(this.reloadAppDataPubSub);
    }
    addMessageListener = () => {
        // 监听postMessage事件（刷新数量）
        !this.isIe() && window.addEventListener("storage", this.receiveMessage, false);
    }
    removeMessageListener = () => {
        !this.isIe() && window.removeEventListener("storage", this.receiveMessage);
    }
    setResolutionprompt = () => {
        this.setState({
            // 电脑分辨率  没有设置过 不是mac系统 不是火狐浏览器
            // showResolutionprompt: (getRatio() === 125 || getRatio() === 150 || getRatio() === 175) && !getStore('zoom') && OSnow() !== 'mac' && Browser() !== 'Firefox'
            // 新的分辨率提示校验
            showResolutionprompt: isShowResolutionprompt(),
        });
    }
    // 隐藏150 提示框
    closeResolutionprompt = () => {
        this.setState({ showResolutionprompt: false });
    }
    // 监听window message，目前用来处理打开已有页签更新sessionStorage
    handleMessage(e) {
        if (e && e.origin === location.origin && Object.prototype.toString.call(e.data) === "[object Object]") {
            const { type, data, crossTabData } = e.data;
            if (type === 'updateAppUrl') {
                // 之前需要更新的情况暂不得知，目前不更新，如果已经打开的页签切换到了卡片页，更新会重写session为列表页，NCC-357752
                // sessionStorage.setItem('NCCAPPURL', data);
            }
            //向当前window广播跨页签数据
            if (crossTabData) {
                window.crossTabData = crossTabData;
                window.postMessage({ type: 'crossTabData', crossTabData });
            }
        }
    }

    handleHashChange = () => {
        this.handleUpdateTitleName();
        //if(!JSON.parse(localStorage.getItem('use_cache_style'))){ // 测试用，测试用  默认发请求查询，加上开关不发请求
        // 这个请求不要，会影响内部页签模式下节点打开效率
        // 重新获取无非就是怕服务端数据有变化（管理员在其他设备更改），这种场景不考虑，已和需求确认
        // this.getDefaultColor();
        //}
        this.handleKnowledge();
    }

    handleKnowledge = () => {
        let { c, ar } = GetQuery(this.props.location.search);
        let knowledgeReqRule = getStore("knowledgeReqRule");
        if (c && ar && (knowledgeReqRule || knowledgeReqRule == "true")) {
            setStore("knowledgeApp", { appcode: c, appid: ar });
            this.getKnowledge();
        }
    }

    //调整产品的缩放比例

    // //监听浏览器缩放
    // handleScreenRationChange = () => {
    //     this.setResolutionprompt();
    //     // let { lastZoom, zoom } = this.state
    //     // if (this.getScreenRation() == 1.5) { //进入到150%比例
    //     //     console.log('进入到1.5比例')
    //     //     this.setState({
    //     //         lastZoom: getStore('zoom'),
    //     //         zoom: 1.5
    //     //     })
    //     //     this.handleZoom(0.8)

    //     // } else if (zoom == 1.5) {
    //     //     console.log('从1.5比例退出')
    //     //     this.setState({ zoom: this.getScreenRation() })
    //     //     this.handleZoom(lastZoom)
    //     // } else {
    //     // }
    // }
    handleZoom = zoom => {
        setStore('zoom', zoom);
        document.body.style.zoom = zoom;
        let ifrs = Array.from(document.querySelectorAll('#iframe'));
        ifrs.forEach(ifr => {
            ifr.contentDocument.body.style.zoom = zoom;
        });
        PubSub.publish('zoomChange', zoom);
    }
    // 关闭分辨率提示弹框 用户
    closeResolutionpromptUser = () => {
        this.setState({ showResolutionPromptUser: false });
    }
    //获取屏幕比例， 比例和浏览器及系统比例有关
    getScreenRation = () => {
        var ratio = 0, screen = window.screen, ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            ratio = window.outerWidth / window.innerWidth;
        }
        if (ratio) {
            ratio = Math.round(ratio * 100);
        }
        return ratio * 0.01;
    };
    /**
     * 更新标题名称
     */
    handleUpdateTitleName() {
        if (isInsideTab()) { return; }

        let { b1, b2, b3, b4, n } = GetQuery(this.props.location.search);
        //更新面包屑
        window.updateBreadcrumb && window.updateBreadcrumb({ b1, b2, b3, b4, n }, null, false);
        if (this.props.location.pathname !== "/") {
            if (isValidString(n)) {
                this.setState({ nodeName: n }, this.updateTitle);
            }
        } else {
            this.setState(
                { nodeName: langCheck("0000PUB-000105") },
                this.updateTitle,
            ); /* 国际化处理： 首页*/
        }
    }
    /**
     * 更新title显示名称
     */
    updateTitle() {
        getWindow().document.title = this.state.nodeName || langCheck("0000PUB-000105") /* 国际化处理： 首页*/;
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.userCode != nextProps.userCode) {
            const { isCaLogin, userCode } = nextProps;
            this.setintervalCA({ isCaLogin, userCode });
        }
    }
    /**
     * spr录制
     */
    handleSprClick() {
        let { sprType } = this.state;
        sprLog(sprType, type => {
            this.setState({ sprType: type });
        });
    }
    /**
     * 页签激活重新查询用户信息
     */
    handleVisibilityChange() {
        if (document.visibilityState !== "hidden") {
            this.connect && this.connect.createWebSocket && this.connect.createWebSocket();
            this.initAppData();
            this.setTimeoutGetMessageCount();
            this.reSetIntervalDisturb();
            //如果重新登录过弹出过退出登录弹框就关闭未登录弹框
            const storeInfoData = getStore('STOREFORINFODATA');
            if (!storeInfoData.abnormalExited && window.__exitTipFlag) {
                this.closeNotLoginModal();
            }
            //缓存语种与当前语种不一致刷新一下页面解决多语不一致问题
            if (window.CURRENT_LANG_CODE && window.CURRENT_LANG_CODE !== getLangCode()) {
                location.reload();
            }
            console.log(langCheck("0000PUB-000133")); /* 国际化处理： 进入*/
            this.setResolutionprompt();
            this.addMessageListener();
        } else {
            this.clearIntervalGetMessage(); //清空消息定时器
            this.clearTimeOutGetMessage(); //清空延时定时器
            this.clearIntervaldisturbTimer(); //清空勿扰定时器
            this.removeMessageListener();
            console.log(langCheck("0000PUB-000134")); /* 国际化处理： 离开*/
        }
    }
    // CA用户拔Key后重新登录
    // 合并
    publishMsg = result => {
        // let _this = this;
        // Ajax({
        //     url: '/nccloud/riawf/publishmsg/QueryPublishCount.do',
        //     type: 'post',
        //     data: "",
        //     async: false, //同步请求  
        //     success: res => {
        let { success, data } = result;
        //setStore("count", data.count);
        if (success && data.rows != "none") {
            let countmsg = getStore("PubMsgCount");
            if (countmsg && countmsg !== "") {
                if (countmsg != data.count) {
                    let { disturbInfo } = this.props;
                    if (
                        (disturbInfo && disturbInfo.isopen) ||
                        (getStore("disturbCount") && getStore("disturbCount") !== "")
                    ) {
                        return;
                    }
                    let msg = data.rows.subject;
                    Notice({
                        status: "info",
                        duration: 3,
                        msg: langCheck("0000PUB-000475") + msg,
                    });
                    setStore("PubMsgCount", data.count);
                }
            } else {
                setStore("PubMsgCount", data.count);
            }
        } else if (success) {
            setStore("PubMsgCount", data.count);
        }
        // },
        // });
    }
    setintervalCA = ({ isCaLogin, userCode }) => {
        if (isCaLogin) {
            const timeFn = setInterval(() => {
                const result = window.superIsUsbKeyExist(userCode);
                if (result.status === 1) {
                    clearInterval(timeFn);
                    ControlTip({
                        status: "warning",
                        title: langCheck("0000PUB-000074") /* 国际化处理： 退出警告！*/,
                        zIndex: 1200,
                        containerClassName: "prompt-abnormal-exit",
                        className: "zIndex10000",
                        msg: result.msg,
                        isCancelBtn: false,
                        onOk: () => {
                            window.logout();
                        },
                    });
                }
            }, 3 * 60 * 1000);
        }
    }
    //2020.12版本去掉心跳请求
    /**
     * 心跳请求定时器
     */
    // setIntervalHeartbeat = () => {
    // 	this.SessionaLive = window.setInterval(() => {
    // 		this.heartbeat();
    // 	}, 20 * 60 * 1000);
    // };
    /**
     * session激活 心跳请求
     */
    // heartbeat = () => {
    // 	let { n = langCheck("0000PUB-000105") } = GetQuery(this.props.location.search); /* 国际化处理： 首页*/
    // 	Ajax({
    // 		url: `/nccloud/platform/pub/sessionalive.do`,
    // 		info: {
    // 			name: n,
    // 			appcode: "10228888",
    // 			action: langCheck("0000PUB-000135") /* 国际化处理： session激活*/
    // 		}
    // 	});
    // };
    // toast点击立即查看回调
    closeCallback() {
        let messageCount = getStore("messageCount");
        if (messageCount && messageCount.newMsgType) {
            pageToWithMsgType.call(this, messageCount.newMsgType);
        }
    }
    // 浏览器notification提醒功能 ==> 内部提示
    showNotification() {
        let { disturbInfo } = this.props;
        if (
            (disturbInfo && disturbInfo.isopen) ||
            (getStore("disturbCount") && getStore("disturbCount") !== "")
        ) {
            return;
        }
        Notice({
            status: "info",
            duration: 3,
            msg: langCheck("0000PUB-000261"),
            cb: this.closeCallback,
        });
    }
    /**
     * 监听postmessage
     */
    receiveMessage(event) {
        if (event.key === "newMessage" && event.newValue == "workBenchMessage") {
            this.clearIntervaldisturbTimer(); //清空勿扰定时器
            this.clearTimeOutGetMessage(); //清空延时定时器
            this.getMessageCount(false);
        }
        if (event.key === "workBenchMsg" && event.newValue == "workBenchMessage") {
            this.setMessageCount(false);
            setStore("workBenchMsg", "");
        }

        if (event.key === "__socket_connect_" && event.newValue == "N") {
            //监听到建立websocket连接的页签关闭，则重新建立连接
            if (!document.hidden && this.connect && this.connect.createWebSocket) {
                this.connect.createWebSocket();
            }
        }
    }
    /**
     * 消息列表接口
     */
    getMessage(page, msgType, callback) {
        let { messageData } = this.props;
        Ajax({
            url: "/nccloud/riart/message/workBenchMessagePushAction.do",
            info: {
                name: langCheck("0000PUB-000113") /* 国际化处理： 消息*/,
                action: langCheck("0000PUB-000317") /* 国际化处理： 查询消息*/,
                appcode: "10228888",
            },
            data: {
                page: page,
                perPage: 10,
                msgType: msgType,
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    // 请求消息主题内容时同时更新数量
                    this.setMessageCount(data, false);
                    if (data.data.ybflag != "0") {
                        this.updateYbmessage();
                    }
                    let preMsg = messageData[`${msgType}item`] ? messageData[`${msgType}item`] : []; //redux里的数据
                    let newData = {
                        ...messageData,
                        [`${msgType}item`]: [...preMsg, ...data.data[`${msgType}item`]],
                        totalcount: data.data.totalcount,
                        refreshtimeinterval: data.data.refreshtimeinterval,
                        currentTime: data.data.currentTime, //服务器当前时间 2111增加
                    };

                    this.props.setMessageData(newData);
                    setStore("newMessage", "");
                }
                callback && callback();
            },
            error: error => {
                console.log(error.data);
                // 如有异常 清空定时器
                this.clearIntervalGetMessage();
                callback && callback();
            },
        });
    }
    // 延迟调用消息接口
    setTimeoutGetMessageCount() {
        let msgInvokingTime = getStore("msgInvokingTime");
        if (this.canLoadMsgCount && msgInvokingTime) {
            let now = moment().format(dateFormat);
            let diffTime = moment(now).diff(msgInvokingTime, "seconds");
            this.setTimeOutGetMessage = setTimeout(() => {
                this.getMessageCount(true);
            }, diffTime * 1000);
        }
    }
    /**
     * 消息列表接口 只请求消息数量计算
     */
    // 合并
    getMessageCount(showNoti = true) {
        this.canLoadMsgCount = false;
        Ajax({
            url: "/nccloud/riart/message/workBenchMessagePushAction.do",
            data: { requestType: "totoalcount" },
            info: {
                name: langCheck("0000PUB-000113") /* 国际化处理： 消息*/,
                action: langCheck("0000PUB-000318") /* 国际化处理： 请求消息数量*/,
                appcode: "10228888",
            },
            success: ({ data }) => {
                this.publishMsg(data); // 合并 QueryPublishCount请求

                if (data.success && data.data) {
                    setStore("workBenchMsg", "workBenchMessage");
                    // 存取当前接口调用时间 打开新页签后延迟调用
                    let now = moment().format(dateFormat);
                    setStore("msgInvokingTime", now);
                    this.setMessageCount(data, showNoti);
                } else {
                    setStore("messageCount", 0);
                }
                if (data.success) {
                    this.canLoadMsgCount = true;
                    this.clearIntervalGetMessage();
                    // 从后台接口取refreshtimeinterval作为定时器间隔分钟数 默认3.
                    let refreshtimeinterval =
                        data.data && data.data.refreshtimeinterval
                            ? +data.data.refreshtimeinterval
                            : 3;
                    this.setIntervalGetMessage = window.setInterval(() => {
                        // this.publishMsg();
                        this.getMessageCount(true);
                    }, refreshtimeinterval * 60 * 1000);
                }
            },
            error: error => {
                console.log(error.data.error.message);
                // 如有异常 清空定时器
                this.clearIntervalGetMessage();
            },
        });
    }
    // 存储消息数量操作
    setMessageCount(data, showNoti) {
        if (!data) {
            return;
        }
        let totalcount = 0;
        if (data.data.unreadpushcount && +data.data.unreadpushcount > 0 && showNoti) {
            this.showNotification();
        }
        let approvecount = data.data.approvecount ? +data.data.approvecount : 0; //审批总数量
        let todocount = data.data.todocount ? +data.data.todocount : 0; //业务总数量
        let prealertcount = data.data.prealertcount ? +data.data.prealertcount : 0; //预警总数量
        let noticecount = data.data.noticecount ? +data.data.noticecount : 0; //通知总数量
        let ybcount = data.data.ybcount ? +data.data.ybcount : 0;
        let serviceurl = data.data.serviceurl;
        totalcount = approvecount + todocount + prealertcount + noticecount + ybcount;
        data.data.totalcount = totalcount;
        setStore("newMessage", "");
        let messageCount = {
            approvecount: approvecount,
            todocount: todocount,
            prealertcount: prealertcount,
            noticecount: noticecount,
            totalcount: totalcount,
            ybcount: ybcount,
            serviceurl: serviceurl,
            ...data.data,
        };
        setStore("messageCount", messageCount);
        this.props.setNewMsg(messageCount);
    }

    updateYbmessage = () => {
        let url = null;
        Ajax({
            url: '/nccloud/riart/message/ybMessageQuery.do',
            data: {},
            success: ({ data }) => {
                if (data.success) {
                    let messageCount = getStore("messageCount");
                    if (data.data.ybtype == "2") {
                        let ybmessage = data.data.ybmessage;
                        messageCount.ybmessage = ybmessage;
                        setStore("messageCount", messageCount);
                    } else {
                        let ybtotal = data.data.ybdata.total;
                        let serviceurl = data.data.ybdata.serviceurl;
                        if ((messageCount.ybcount != ybtotal) || messageCount.serviceurl != serviceurl) {
                            if ((messageCount.ybcount != ybtotal)) {
                                messageCount.totalcount = messageCount.totalcount - parseInt(messageCount.ybcount) + parseInt(ybtotal);
                                //messageCount.totalcount = 25;
                                messageCount.ybcount = ybtotal;
                            }
                            if (serviceurl) {
                                if (messageCount.serviceurl != serviceurl) {
                                    messageCount.serviceurl = serviceurl;
                                }
                            }
                            setStore("messageCount", messageCount);
                            /* messageCount = {
                                 approvecount: messageCount.approvecount,
                                 todocount: messageCount.todocount,
                                 prealertcount: messageCount.prealertcount,
                                 noticecount: messageCount.noticecount,
                                 totalcount: messageCount.totalcount,
                                 ybcount: messageCount.ybcount,
                                 serviceurl:messageCount.serviceurl,
                                 ...messageCount,
                             };
                             this.setState({
                                 messageCount: messageCount,
                             });
                             setStore("messageCount", messageCount);
                             */
                            this.props.setNewMsg(messageCount);
                            // this.forceUpdate();
                        }
                    }

                }

            },
            error: error => {
                console.log(error);
            },
        });
    }
    /**
     * 获取知识列表
     */
    getKnowledge() {
        let knowledgeApp = getStore("knowledgeApp");
        let { n } = GetQuery(this.props.location.search);
        if (!knowledgeApp) {
            return;
        }
        if (n && knowledgeApp.appcode && knowledgeApp.appid) {
            Ajax({
                url: "/nccloud/ssckm/maintain/KmGetKnowledgeByAppAction.do",
                data: {
                    appcode: knowledgeApp.appcode,
                    appid: knowledgeApp.appid,
                },
                info: {
                    name: langCheck("0000PUB-000279") /* 国际化处理： 知识查看*/,
                    action: langCheck("0000PUB-000319"), /* 国际化处理： 查询知识列表*/
                },
                noNeedShowError: true,
                success: ({ data }) => {
                    if (data.success && data.data) {
                        this.props.setKnowledgeRule(true);
                        this.props.setKnowledge(data.data);
                    } else {
                        this.props.setKnowledgeRule(false);
                    }
                },
                error: error => {
                    let data = error.data;
                    if (!data.success) {
                        this.props.setKnowledgeRule(false);
                    }
                },
                errorCatch: error => {
                    const status = error.status || (error.response ? error.response.status : 200);
                    //共享服务不可用时禁用提示
                    return status !== 503;
                },
            });
        }
    }
    /**
     * 消息列表 心跳请求
     */
    didMountGetMessage() {
        let now = moment().format(dateFormat);
        let msgInvokingTime = getStore("msgInvokingTime");
        if (msgInvokingTime) {
            let diffTime = moment(now).diff(msgInvokingTime, "seconds");
            setTimeout(() => {
                this.getMessageCount(false);
            }, diffTime * 1000);
        } else {
            this.getMessageCount(true);
        }
    }
    /**
     * 消息列表 清空定时器
     */
    clearIntervalGetMessage() {
        this.setIntervalGetMessage && clearInterval(this.setIntervalGetMessage);
    }
    /**
     * 消息列表 清空延时定时器
     */
    clearTimeOutGetMessage() {
        this.setTimeOutGetMessage && clearTimeout(this.setTimeOutGetMessage);
        // this.resolutionprompt && clearTimeout(this.resolutionprompt);
        this.timer && clearTimeout(this.timer);
    }
    /**
     * 清空勿扰模式定时器
     */
    clearIntervaldisturbTimer() {
        this.disturbTimer && clearInterval(this.disturbTimer);
    }
    /**
     * 应用关闭事件
     */
    appClose() {
        let { n } = GetQuery(this.props.location.search);
        if (!n) {
            n = langCheck("0000PUB-000105"); /* 国际化处理： 首页*/
        }
        window.proxyAction &&
            window.proxyAction(null, null, `${n}-${langCheck("0000PUB-000139")}`)(); /* 国际化处理： 关闭*/
        // 关闭socket 链接
        this.connect && this.connect.closeSocket && this.connect.closeSocket();
    }
    /**
     * 预警消息查询 其中包含常规预警及到期预警
     */
    alertmsg() {
        let { c, n } = GetQuery(this.props.location.search);
        n = n ? n : langCheck("0000PUB-000105"); /* 国际化处理： 首页*/
        Ajax({
            url: `/nccloud/platform/appregister/queryalertmessages.do`,
            data: { appcode: c },
            info: {
                name: n,
                action: langCheck("0000PUB-000137") /* 国际化处理： 预警消息*/,
                appcode: "10228888",
            },
            success: ({ data: { data } }) => {
                if (data) {
                    let { alertMessageVOList, validDayCount } = data;
                    if (alertMessageVOList.length > 0) {
                        alertMessageVOList.map(({ alertFileUrl, alertName }) => {
                            const content = alertName.substr(0, alertName.indexOf("["));
                            let alertDate = alertName.substr(alertName.indexOf("["));
                            alertDate = alertDate.substr(1, alertDate.length - 2);
                            const localTime = DongbaToLocalTime(moment(alertDate)).format(
                                dateFormat,
                            ); //将服务器时间转成本地时间
                            Notice({
                                status: "earlyWarning",
                                duration: null,
                                // 改成了不返回全路径，需要前端拼接一下（'fs/service/riamsgattachfiles/ufiles/78561e6a-b8da-4a46-b700-0c41c6805621?params=KmTyroTfFmOK1_21pKGzAxeps7Ay9'）
                                url: alertFileUrl.startsWith('http') ? alertFileUrl : `${window.location.origin}/${alertFileUrl}`,
                                msg: `${content}[${localTime}]`,
                            });

                        });
                    }
                    if (validDayCount) {
                        validDayCount = validDayCount - 0 > 0 ? validDayCount - 0 : 0;
                        if (validDayCount < 31) {
                            Notice({
                                status: "overdueWarning",
                                day: validDayCount,
                            });
                        }
                    }
                }
            },
        });
    }
    // 账户数据控制器
    accountDataController(data) {
        // 当切换集团时刷新页面
        if (data.groupId && this.props.groupId.length > 0 && data.groupId !== this.props.groupId) {
            // 刷新页面
            clearUrlParams(); //解决YBP-FI-BUG-6137
            window.location.reload(true); 
        }
        // 换了个用户登录
        if (this.props.userId) { // 记录上一次用户
            this.oldUserId = this.props.userId;
        }
        if (data.userId && this.oldUserId && data.userId !== this.oldUserId) {
            clearUrlParams(); //解决YBP-FI-BUG-6137
            window.location.reload(true);
        }
        // const arr = data.userName.split(' ');
        // const pictureName = arr.length > 1 ? arr[0].substring(0, 1) + arr[1].substring(0, 1) : arr[0].substring(0, 2);
        // data.pictureName = pictureName;
        this.props.setAccountInfo(data);
    }
    // 数据更新
    appDataUpdate(businessCallback) {
        let { c = "10228888", n = langCheck("0000PUB-000105") /* 国际化处理： 首页*/ } = GetQuery(
            this.props.location.search,
        );
        APPDataController({
            AccountDataController: this.accountDataController, // 账户信息
            PEDataController: PEDataController({
                nodeName: n,
                nodeCode: c,
            }), // FE 数据
            BusinessInfoController: BusinessInfoController(allowPaint => {
                // 业务数据
                this.props.updateAllowPaint(allowPaint);
                businessCallback && businessCallback();
            }),
            UserAvatarDataController: this.props.setAvatar, // 用户头像
        });
    }
    // 设置默认主题 新用户没设置过主题时 两个字段需接口返回
    setDefault(
        color = subjectDefaultData.defaultLight,
    ) {
        if (!window.nccColor || (window.nccColor && window.nccColor !== "")) {
            const { bdtype, bgColor: bdcolor, blurNumber: bdpicdim, bgImg: bdpicture } = subjectDefaultData.defaultBackgroundObject;
            const distance = 'tight'; //默认紧凑
            //  屏幕缩放 150时 adaptive 其他按 100处理 fixed 
            const ratio = getRatio();
            const pagewidth = ratio === 150 ? 'adaptive' : 'fixed';
            const { changeBgState } = this.props;
            const icon = "";
            let checkedColor = subjectDefaultData.colorMap[color];
            this.props.setThemeColor({ type: checkedColor, name: langCheck('0000PUB-000484' /*默认浅*/), color }); //store
            this.props.setNccFont(setNccFontSize()); //设置 store字体大小
            window.nccColor = checkedColor;
            window.nccIcon = icon || "";
            const nccCardlAndDesktop = {
                cardInterval: distance, //卡片间隔
                desktopWidth: pagewidth, //桌面宽度
            };
            window.nccCardlAndDesktop = nccCardlAndDesktop;
            // localStorage存颜色
            setStore("nccColor", checkedColor);
            setStore("nccIcon", icon || "");
            setStore("nccCardlAndDesktop", nccCardlAndDesktop);
            // 背景
            const backgroundObject = {
                bgImg: bdpicture,
                bgColor: bdcolor,
                blurNumber: bdpicdim,
                bdtype: bdtype,
            };
            changeBgState(backgroundObject);

            // 更换plantform.css
            setThemeAndIframe(checkedColor);
            // 更换body class
            setBodyClass({ themeType: checkedColor });
            setNccFormStyle();
            setNccTableStyle();
        }
    }

    setCacheTheme() {
        const nccTheme = getStore('nccTheme');
        if (nccTheme) {
            const { type, color } = nccTheme;
            this.props.setThemeColor(nccTheme); // store
            setThemeAndIframe(type, color);
            setBodyClass({ themeType: type });
            window.nccColor = type;
        }
        const nccFontSize = getStore('nccFontSize');
        if (nccFontSize) {
            setNccFontSize(nccFontSize);
        }
    }

    // 删除当前生效主题时 需要设置下默认主题 不然一直会有提示
    setDefaulColortAfterDelete = obj => {
        const { selectCorporateStyle, pk_corporatestyle, pk_themecolor } = obj;
        const infoData = getStore("STOREFORINFODATA", true);
        const pk_group = infoData && infoData.groupVOs && infoData.groupVOs.filter((item => item.is_selected))[0].pk_group;
        Ajax({
            url: "/nccloud/platform/appregister/setdefaultstheme.do",
            data: {
                color: subjectDefaultData.defaultLight,
                name: langCheck("0000PUB-000282"),
                pk_corporatestyle,
                pk_themecolor,
                selectCorporateStyle,
                pk_group,
            },
            // success: ({ data, }) => {}
        });
    }
    backWorkbenchStyle = null;
    // 获取主题颜色
    getDefaultColor(callback) {
        const { changeBgState, setNccFont, setThemeColor } = this.props;
        Ajax({
            url: "/nccloud/platform/appregister/queryworkbenchstyle.do", //querythemecolor 原接口
            data: {},
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000320") /* 国际化处理： 查询主题颜色*/,
                appcode: "10228888",
            },
            noNeedShowError: true,
            success: res => {
                const { success } = res.data;
                if (!success || _.isEqual(this.backWorkbenchStyle, res.data.data)) {
                    // 没有变化时阻止，后续的不需要执行
                    return;
                }
                this.backWorkbenchStyle = _.cloneDeep(res.data.data);

                const data = res.data.data.CorporateStyleVO;
                const { WaterMarkAggVO } = res.data.data;
                let resWatermark = {};
                if (WaterMarkAggVO) {
                    const { waterMarkAssignAppCodes = {} } = WaterMarkAggVO;
                    const { watermarkSetting } = getWaterMarkObject(WaterMarkAggVO);
                    const { openapp = [], openprint = [] } = waterMarkAssignAppCodes;
                    setStore('nccWatermark', { ...watermarkSetting, openapp, openprint }); // 存一下，别的领域会用到
                    resWatermark = {
                        enable: watermarkSetting.usewatermark,
                        config: watermarkSetting,
                        enableApps: watermarkSetting.useallapppage ? ['all'] : openapp,
                    }
                }
                this.props.setWatermarkInfo({
                    enable: false,
                    config: {},
                    enableApps: [],
                    ...resWatermark,
                });
                if (data) {
                    const { tabstyle, isDefault, customtheme_del, selectCorporateStyle, formupdownstyle, formunderlinestyle, formtitlecolor } = data;
                    setInsideTab(tabstyle);
                    if (isDefault || customtheme_del) {
                        if (customtheme_del && selectCorporateStyle) {
                            Notice({
                                status: "warning",
                                msg: langCheck("0000PUB-000487"), /*当前主题色已删除，恢复默认主题*/
                            });
                            this.setDefaulColortAfterDelete(data);
                        }
                        // 走默认样式 
                        const {
                            color = subjectDefaultData.defaultLight,
                            rowcheckedbutton,
                            inputdataformat = false,
                        } = data;
                        this.setDefault(color, rowcheckedbutton, inputdataformat);
                    } else {
                        //  屏幕缩放 150时 adaptive 其他按 100处理 fixed 
                        const ratio = getRatio();
                        const defaultPagewidth = ratio === 150 ? 'adaptive' : 'fixed';
                        const {
                            color,
                            icon,
                            tabletype,
                            crossCheck,
                            cuttingCheck,
                            fontSize,
                            pagewidth = defaultPagewidth,
                            distance = 'tight',
                            rowcheckedbutton,
                            inputdataformat,
                            name,
                            pk_customtheme, // 自定义的
                            tablehdbgcolor,
                            selectedrowcolor
                        } = data;
                        let checkedColor = pk_customtheme ? 'mixin' : subjectDefaultData.colorMap[color];
                        setThemeColor({ type: checkedColor, name, color, pk_customtheme }); //设置 store主题色
                        setNccFont(setNccFontSize(fontSize)); //设置 store字体大小
                        // 背景
                        const backgroundObject = getBackgroundObject(data);
                        window.nccColor = checkedColor;
                        window.nccIcon = icon || "";
                        const nccCardlAndDesktop = {
                            cardInterval: distance, //卡片间隔
                            desktopWidth: pagewidth, //桌面宽度

                        };
                        window.nccCardlAndDesktop = nccCardlAndDesktop;
                        changeBgState(backgroundObject); //背景
                        this.setDesktopGap(distance); //桌面间隔
                        // localStorage存颜色
                        setStore("nccColor", checkedColor);
                        setStore("nccIcon", icon || "");
                        setStore("nccCardlAndDesktop", nccCardlAndDesktop);
                        // 如果返回空对象，设置默认模式
                        // if (Object.keys(data.data).length == 0 || color == "#F1F1F1") { //之前的逻辑 注释备用
                        if (Object.keys(data).length == 0) {
                            this.setDefault();
                            return;
                        }
                        this.setState({ logo: data.nvigapic });
                        // 更换body class
                        setBodyClass({ themeType: checkedColor });
                        setThemeAndIframe(checkedColor, color);
                        setNccFormStyle({
                            formupdownstyle,
                            formunderlinestyle,
                            formtitlecolor,
                        });
                        setNccTableStyle({
                            tableType: tabletype,
                            crossCheck: crossCheck,
                            cuttingCheck: typeof cuttingCheck === 'boolean' ? cuttingCheck : true,
                            rowcheckedButton: rowcheckedbutton,
                            inputdataformat,
                            tablehdbgcolor,
                            selectedrowcolor,
                        })
                    }
                } else {
                    this.setDefault();
                    // TODO

                }
                callback && callback();
            },
            error: () => {
                this.setDefault();
                // TODO

            },
        });
    }
    //设置桌面间隔
    setDesktopGap = cardInterval => {
        const margin = cardIntervalFormat(cardInterval);
        if (margin) {
            this.props.setGridMargin(+margin);
        }
    }
    // 获取勿扰模式信息
    getDistubInfo(flag = true) {
        if (flag) {
            let { n } = GetQuery(this.props.location.search);
            if (n && n !== "null" && this.props.location.pathname !== "/") {
                return;
            }
        }
        setStore("disturbCount", "");
        setStore("duetime", "");
        Ajax({
            url: "/nccloud/platform/appregister/querydistrub.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000333") /* 国际化处理： 勿扰模式*/,
                action: langCheck("0000PUB-000335"), /* 国际化处理： 勿扰模式查询*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    let Info = data.data;
                    this.props.setDisturbMode(Info);
                    if (Info.isopen && Info.duetime) {
                        // 生效时间
                        let now = moment().format(dateFormat);
                        let diffTime = moment(Info.duetime).diff(now, "minutes");
                        if (diffTime <= 0) {
                            // 关闭勿扰模式
                            this.closeDisturbMode();
                            return;
                        }
                        setStore("duetime", Info.duetime);
                        setStore("disturbCount", diffTime);
                        this.setIntervalDisturb();
                    } else {
                        // 清空定时器
                        setStore("disturbCount", "");
                        this.clearIntervaldisturbTimer();
                    }
                }
            },
        });
    }
    onUserSelectModule(moduleInfo) {
        this.setState(preState => ({ navAppInfo: { ...preState.navAppInfo, ...moduleInfo } }));
    }
    // 页签激活 重新计算勿扰定时时间
    reSetIntervalDisturb() {
        let now = moment().format(dateFormat);
        let duetime = getStore("duetime");
        let disturbCount = getStore("disturbCount");
        if (duetime !== "" && disturbCount !== "") {
            let diffTime = moment(duetime).diff(now, "minutes");
            if (diffTime <= 0) {
                // 关闭勿扰模式
                this.closeDisturbMode();
                return;
            }
            setStore("disturbCount", diffTime);
            this.setIntervalDisturb();
        }
    }
    // 勿扰模式定时器
    setIntervalDisturb() {
        // 定时器
        let num = getStore("disturbCount");
        if (typeof num !== "string" || +num <= 0) {
            return;
        }
        try {
            let setDisCount = () => {
                if (num == 0) {
                    clearInterval(this.disturbTimer);
                    // 关闭勿扰模式
                    this.closeDisturbMode();
                    return;
                } else {
                    num--;
                }
                setStore("disturbCount", num);
            };
            this.disturbTimer = setInterval(setDisCount, 60 * 1000);
        } catch (error) {
            this.clearIntervaldisturbTimer();
        }
    }
    // 关闭勿扰模式
    closeDisturbMode() {
        let { disturbInfo } = this.props;
        let pdata = {
            isopen: false,
            isdark: false,
            entrytime: disturbInfo.entrytime || "0.5",
            duetime:
                disturbInfo.duetime ||
                moment()
                    .add("0.5", "hours")
                    .format(dateFormat),
            pk_distutb: disturbInfo.pk_disturb ? disturbInfo.pk_disturb : null,
        };
        Ajax({
            url: "/nccloud/platform/appregister/savedistrub.do",
            data: pdata,
            info: {
                name: langCheck("0000PUB-000258") /* 国际化处理： 主题设置*/,
                action: langCheck("0000PUB-000320"), /* 国际化处理： 查询主题颜色*/
            },
            success: ({ data }) => {
                if (data.success && data.data) {
                    setStore("disturbCount", "");
                    setStore("duetime", "");
                    let Info = data.data;
                    this.props.setDisturbMode(Info);
                    // this.setDefault();
                } else {
                    // this.setDefault();
                }
            },
        });
    }
    // 查询知识管理安装权限
    getKnowledgeRuleOnce() {
        Ajax({
            url: "/nccloud/platform/appregister/queryappknowledgeaction.do",
            data: {},
            info: {
                name: langCheck("0000PUB-000279") /* 国际化处理： 知识查看*/,
                action: langCheck("0000PUB-000321") /* 国际化处理： 查询知识权限*/,
                appcode: "10228888",
            },
            noNeedShowError: true,
            success: ({ data }) => {
                if (data.success) {
                    setStore("knowledgeReqRule", data.data);
                }
            },
            error: () => {
                this.props.setKnowledgeRuleOnce(false);
            },
        });
    }
    // 刷新从新设置当前时间
    layoutRefresh() {
        let now = moment().format(dateFormat);
        setStore("msgInvokingTime", now);
    }
    // ie
    isIe() {
        let flag;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            flag = true;
        } else {
            flag = false;
        }
        return flag;
    }
    //监听键盘按键事件
    handleHotKey(event) {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        switch (e && e.keyCode) {
            case 27: //按ESC关闭菜单（为自动化测试添加）
                if (this.state.showAllApp) {
                    this.changeAllApp(); //关闭全部应用菜单
                }
                if (this.props.isOpen) {
                    this.props.changeDrawer(false); //关闭用户信息
                }
                break;
            default:
                break;
        }
    }
    //为了解决ie下点击全部应用浏览器假死问题 add by:liyaoh
    changeAllApp(flag) {
        let showAllApp = typeof flag === "boolean" ? flag : !this.state.showAllApp;
        let navAppInfo = this.state.navAppInfo ? { ...this.state.navAppInfo } : GetQuery(this.props.location.search);
        this.setState({ showAllApp, navAppInfo });
        this.props.setBreadCrumbClick(false);
    }
    onBreadCrumbClick(bcInfo) {
        this.setState({
            showAllApp: true,
            navAppInfo: bcInfo,
        });
        this.props.setBreadCrumbClick(true);
    }
    //关闭未登录弹框
    closeNotLoginModal() {
        const abnormalModal = document.querySelector('.prompt-abnormal-exit');
        if (abnormalModal) {
            abnormalModal.remove();
        }
        window.__exitTipFlag = false;
    }
    //控制导航栏+标签栏显隐
    handleNavVisible() {
        let hideNav = this.props.location.search.indexOf('hideNav=true') !== -1;//由于业务设置等节点url中含有page，getQuery解析不出来hideNav,这里做个兼容
        if (!hideNav) {
            const querys = GetQuery(this.props.location.search);
            hideNav = querys.hideNav;
        }
        if (hideNav) {
            try {
                if (JSON.parse(hideNav) == true) {
                    this.setState({ hideNav: true });
                }
            } catch (error) {
                console.error("hideNav参数必须是Boolean类型");
            }
        }
    }

    // 监听内部页签数据变化
    handleTabChange(type, value) {
        if (type === 'navShow') {
            this.setState({ navShow: !this.state.navShow });
        }
        if (type === 'tabActived') {
            this.setState({ tabActived: value });
        }
    }
    closeAllApp() {
        this.setState({ showAllApp: false });
    }
    // // 获取分辨率提示高度
    // getResolutionHeight = () => {
    //     const resolutionDom = document.querySelector('.resolution-prompt');
    //     let height = 42;
    //     if (resolutionDom) {
    //         height = resolutionDom.clientHeight;
    //     }
    //     return height;
    // }

    // 处理导航栏事件
    handleNavEvent = (val) => {
        const { type, data } = val;
        if (type === 'app-click') { this.changeAllApp(); }
        if (type === 'breadcrumb-click') { this.onBreadCrumbClick(...data); }
        if (type === 'get-message') { this.getMessage(...data); }
    }

    // 渲染水印
    renderWatermark = ({ children, appcode, key = 'nc-watermark', className = 'nc-watermark', style = {}, enable = true }) => {
        const { allowPaint, watermarkInfo, businessDate } = this.props;
        const noWatermarkApps = getStore('noWatermarkApps') || [];
        // 允许绘制（需要依赖业务数据）
        const renderable = allowPaint;
        let watermarkConfig = watermarkInfo.config;
        if (renderable && businessDate) {
            if (watermarkConfig.ts && businessDate !== watermarkConfig.ts) { // 业务日期变化之后，触发水印内容重新计算
                watermarkConfig = { ...watermarkConfig }
            }
            watermarkConfig.ts = businessDate;
        }
        return renderable
            ? <Watermark
                key={key}
                className={className}
                style={style}
                enable={
                    !isNestedWorkbench() &&
                    enable && // 是否需要水印
                    watermarkInfo.enable && // 水印是否启用
                    (watermarkInfo.enableApps.includes('all') || watermarkInfo.enableApps.includes(appcode)) && // 在启用范围内
                    !noWatermarkApps.includes(appcode)
                }
                watermarkSetting={watermarkConfig}
            >
                {children}
            </Watermark>
            : null;
    }

    // 更新微应用相关（存在主应用上的信息）
    handleUpdateMicroOnMain = (upData, appKey) => {
        const { type, data } = upData;
        if (!type || !data) { return; }

        // { type: 'breadcrumb', data: function/object }
        if (type === 'breadcrumb') {
            window.updateBreadcrumb(data, appKey);
            return;    
        }

        if (isInsideTab()) {
            this.browserTabRef.updateMicroOnMain(upData, appKey);
        } else {
            if (type === 'tabTitle') {
                getWindow().document.title = data;
            } else {
                const { microTempData = {} } = this.state;
                this.setState({
                    microTempData: { ...microTempData, [type]: data }
                })
            }
        }
    }

    // 控制全屏，给领域用的，节点最大化
    handleControlAppScreen = (type) => {
        const insideTab = isInsideTab();
        if (type === 'requestFullscreen') {
            if (insideTab) {
                // 让内部页签的内容区域全屏化，这样能保证最大化之后跳转到其他节点功能完整
                this.browserTabRef.contentRef.requestFullscreen();
            } else {
                document.getElementById('mainiframe').requestFullscreen();
            }
        }
        if (type === 'exitFullscreen') {
            if (insideTab) {
                if (document.fullscreenElement === this.browserTabRef.contentRef) {
                    document.exitFullscreen();
                }
            } else {
                if (document.fullscreenElement === document.getElementById('mainiframe')) {
                    document.exitFullscreen();
                }
            }
        }
        if (type === 'getFullscreen') {
            if (insideTab) {
                return document.fullscreenElement === this.browserTabRef.contentRef;
            } else {
                return document.fullscreenElement === document.getElementById('mainiframe');
            }
        }
    }

    getWatermarkEnable = (querys) => {
        const { microTempData } = this.state;
        const { location } = this.props;
        if (microTempData && microTempData.hasOwnProperty('watermark')) {
            return microTempData.watermark.enable;
        }
        if (querys.ifr) {
            const ifrQuerys = GetQuery(querys.ifr);
            if (ifrQuerys.noWatermark === 'true') { // 适用于通过openTo打开节点不想要水印
                return false;
            }
        }
        return !NoNeedWatermarkRoutes.includes(location.pathname);
    }

    isHome = () => {
        const pathHome = this.props.location.pathname === '/';
        if (isInsideTab()) {
            return pathHome && this.state.tabActived === 0;
        } else {
            return pathHome;
        }
    }

    handleTabRefresh = () => {
        // 刷新重新获取水印数据
        this.getDefaultColor();
    }

    render() {
        let { nodeName, navShow, hideNav, showResolutionprompt, logo, systemNotifiC: SystemNotifiC } = this.state;
        let {
            is_cloud_register,
            deployType,
            needBind,
            isRealAuth,
            children,
            location,
            userId,
            workbenchData,
        } = this.props;
        const querys = GetQuery(location.search);
        let renderKnow = querys && querys.hasOwnProperty("n");
        const { previewMode, editable } = querys;
        // const resolutionHeight = this.getResolutionHeight();
        const navVisible = !(hideNav || !navShow);
        const navStyle = navVisible ? {} : { display: 'none' };
        const insideTab =  isInsideTab();
        return (
            <div className={`nc-workbench-layout ${previewMode ? 'preview' : ''}`}>
                {/* serverLocation="172.20.53.89:8883"  */}
                <ConnectSocket
                    ref={e => {
                        this.connect = e;
                    }}
                    userId={userId}
                    onMessage={() => {
                        // console.log("消息回调");
                    }}
                />
                {
                    // 分辨率提示
                    showResolutionprompt && !previewMode && navVisible && <ResolutionPrompt
                        closeResolutionprompt={this.closeResolutionprompt}
                    />
                }
                {
                    (previewMode || editable) && <div className="preview-prompt">
                        {langCheck(
                            editable
                            ?
                            '0000PUB-000677'
                            :
                            (previewMode === 'modal'
                                ? (navVisible ? '0000PUB-000679' : '0000PUB-000556')
                                : '0000PUB-000555'
                            ), false, null, [workbenchData && workbenchData.length && workbenchData[0].name]
                        )}
                    </div>
                }
                {
                    <div
                        fieldid={`microapp-content-actived`}
                        className={`nc-workbench-top-container nccwb-top ${editable ? 'disabled' : ''}`} // 设计器模式禁用导航栏
                        style={navStyle}
                    >
                        {/* 导航栏 */}
                        <NavBar
                            fieldid={nodeName}
                            onNavHandle={this.handleNavEvent}
                            navConfig={{
                                logo,
                                showCrumb: !this.isHome(),
                                isHome: this.isHome()
                            }}
                        />
                        {renderKnow && <Knowledge />}
                    </div>
                }
                {
                    insideTab === null
                    ?
                    null
                    :
                    (
                        insideTab
                        ?
                        <BrowserTab
                            hideNav={this.state.hideNav}
                            children={children}
                            closeAllApp={this.closeAllApp.bind(this)}
                            onTabChange={this.handleTabChange}
                            navShow={navShow}
                            location={this.props.location}
                            alertMsg={this.alertmsg} //打开节点调用报警函数
                            renderWatermark={this.renderWatermark}
                            ref={ref => this.browserTabRef = ref}
                            rootInstance={this.props.rootInstance}
                            changeAllApp={this.changeAllApp}
                            onTabRefresh={this.handleTabRefresh}
                        >
                        </BrowserTab>
                        :
                        // nc-workbench-container 这个类名不要轻易改，参照通过这个类名判断是否在首页，然后弹窗挂在该容器内部
                        <div className='nc-workbench-container' fieldid={`microapp-content-actived`}>
                            { this.renderWatermark({
                                children,
                                appcode: querys.c,
                                className: 'nc_workbench-container-content',
                                enable: this.getWatermarkEnable(querys)
                            }) }
                        </div>
                    )
                }
                {
                    <SideDrawer
                        navAppInfo={this.state.navAppInfo}
                        showAllApp={this.state.showAllApp}
                        changeAllApp={this.changeAllApp}
                        getDistubInfo={this.getDistubInfo}
                        onUserSelectModule={this.onUserSelectModule}
                        isHome={this.isHome()}
                        className={`${navVisible ? '' : 'no-nav'}`}
                    />
                }

                <AccountActivationEntry
                    needBind={needBind}
                    updateAPPDataStore={() => { this.initAppData(true); }}
                />
                {
                    //  已绑定 未实名认证 云注册 公有云 
                    !needBind && !isRealAuth && !getStore('isRealName') && is_cloud_register && deployType === 'cloud' && <RealNameAuthentication
                        updateAPPDataStore={() => { this.initAppData(true); }}
                    />
                }

                {/* {
                    showResolutionPromptUser && <ResolutionPromptUser
                        closeResolutionpromptUser={this.closeResolutionpromptUser}
                        showResolutionPromptUser={showResolutionPromptUser}
                        resolutionPromptUserType={resolutionPromptUserType}
                    />
                } */}
                
                {
                    !needBind && typeof SystemNotifiC === 'function'
                    ?
                    <SystemNotifiC
                        isInsideTab={insideTab}
                        isHome={this.isHome()}
                    />
                    :
                    null
                }
            </div >
        );
    }
}
Layout.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    avatar: PropTypes.string.isRequired,
    changeBgState: PropTypes.func.isRequired,
    businessDate: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    userCode: PropTypes.string.isRequired,
    isCaLogin: PropTypes.bool.isCaLogin,
    userName: PropTypes.string.isRequired,
    groupId: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    projectCode: PropTypes.string.isRequired,
    changeDrawer: PropTypes.func.isRequired,
    setAccountInfo: PropTypes.func.isRequired,
    setAvatar: PropTypes.func.isRequired,
    is_cloud_register: PropTypes.bool.isRequired,
    deployType: PropTypes.bool.isRequired,
    needBind: PropTypes.bool.isRequired,
    updateAllowPaint: PropTypes.func.isRequired,
};
export default withRouter(
    connect(
        state => ({
            isOpen: state.appData.isOpen, // 账号设置侧拉是否打开
            avatar: state.appData.avatar,
            userId: state.appData.userId,
            userCode: state.appData.userCode,
            isCaLogin: state.appData.isCaLogin,
            userName: state.appData.userName,
            groupId: state.appData.groupId,
            groupName: state.appData.groupName,
            projectCode: state.appData.projectCode,
            businessDate: state.appData.businessDate,
            is_cloud_register: state.appData.is_cloud_register,
            deployType: state.appData.deployType,
            needBind: state.appData.needBind,
            isRealAuth: state.appData.isRealAuth,
            messageData: state.appData.messageData,
            knowledgeData: state.appData.knowledgeData,
            knowledgeReqRule: state.appData.knowledgeReqRule,
            disturbInfo: state.appData.disturbInfo,
            themeColor: state.appData.themeColor,
            workbenchData: state.appData.workbenchData,
            watermarkInfo: state.appData.watermarkInfo,
            allowPaint: state.ifrData.allowPaint,
        }),
        {
            changeDrawer,
            changeBgState,
            setAccountInfo,
            setAvatar,
            updateAllowPaint,
            setMessageData,
            setKnowledgeRule,
            setKnowledge,
            setKnowledgeRuleOnce,
            setDisturbMode,
            setNewMsg,
            setGridMargin,
            setBreadCrumbClick,
            setThemeColor,
            setNccFont,
            setWorkbenchData,
            setWatermarkInfo,
        },
    )(Layout),
);

